var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("Welcome, "+_vm._s(_vm.displayName))]),_c('div',[_vm._v("Please click on a session to join it, or create a new one.")]),_c('br'),_c('SessionCreate',{on:{"created":_vm.onSessionCreated}}),_c('SessionList',{attrs:{"userId":_vm.$store.getters.user.userId},on:{"selectSession":_vm.joinSession}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }